<template>
  <a-card class="style1">
    <h2>Product Categories</h2>

    <a-button type="primary" class="my-3" @click="$router.push({ name: 'AdminProductCategoryDetail', params: { id: 'create' } })">Create Category</a-button>
    <a-table :loading="isLoading" :columns="columns" :data-source="categoryData" size="middle" bordered rowKey="id">
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record.id)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="name" slot-scope="record">
        <a href="javascript:;" @click="onEdit(record.id)">{{ record.name }}</a>
      </div>
      <div slot="image" slot-scope="text, record" class="text-center">
        <img :src="record.thumbnail" alt="back" class="mh-200p cursor-pointer" @click="viewImage(record.thumbnail)" style="max-width: 150px;" />
      </div>
      <template slot="description" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <div slot="store" slot-scope="text, record">
        <a-select :default-value="record.store" :showArrow="false" @change="e => handleStoreChange(e, record)" style="min-width: 120px;">
          <a-select-option v-for="(store, index) in stores" :value="store.value" :key="index">
            {{ store.text }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>

    <CoolLightBox :items="items" :index="index" @close="index = null" :disable-zoom="true" :close-on-click-outside-mobile="true" />
  </a-card>
</template>
<script>
import { slugData } from '@/utils';
import AdminService from '@/services/AdminService';
import { includes } from 'lodash';
export default {
  data() {
    const stores = [
      { text: 'All', value: null },
      { text: 'Jesus Story', value: 'story' },
      { text: 'Pastor', value: 'invitation' },
    ];

    return {
      isLoading: true,
      stores,
      items: [],
      index: null,
      categoryData: [],
      categoryList: [],
      columns: [
        {
          title: 'Name',
          key: 'name',
          width: 200,
          scopedSlots: {
            customRender: 'name',
          },
        },
        {
          title: 'Image',
          key: 'image',
          dataIndex: 'thumbnail',
          scopedSlots: {
            customRender: 'image',
          },
        },
        {
          title: 'Description',
          key: 'description',
          dataIndex: 'description',
          scopedSlots: {
            customRender: 'description',
          },
        },
        {
          title: 'Store',
          key: 'store',
          dataIndex: 'store',
          scopedSlots: {
            customRender: 'store',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (!['operation', 'image', 'store'].includes(item.key)) {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    categoryList: {
      async handler(val) {
        this.categoryData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async doInitData() {
      this.categoryList = await AdminService.store.getCategories();
    },
    onEdit(id) {
      this.$router.push({ name: 'AdminProductCategoryDetail', params: { id } });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.store.deleteCategory(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.name} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },
    async handleStoreChange(value, record) {
      this.isLoading = true;

      await AdminService.store.updateCategory(record.id, {
        store: value,
      });
      this.isLoading = false;
    },
    handleReset(clearFilters) {
      clearFilters();
    },
    viewImage(url, title) {
      this.items = [
        {
          src: url,
          title: title,
        },
      ];
      this.index = 0;
    },
  },
};
</script>
<style lang="scss">
.cool-lightbox .cool-lightbox__slide .cool-lightbox__slide__img {
  width: auto;
  max-width: 480px;
}
</style>
